import { prospectDemoReferenceExecution } from "@clickdialog/solution-contract";
import type { DemoManifest } from "../../../types";

const EXECUTION = prospectDemoReferenceExecution(
  "home-services.renovation.maison-morel-v1",
);
if (!EXECUTION || EXECUTION.target.kind !== "unavailable") {
  throw new Error("renovation_reference_execution_invalid");
}

export const RENOVATION_MAISON_MOREL_REFERENCE_DEMO: DemoManifest = Object.freeze({
  id: "home-services.renovation.maison-morel-v1",
  name: "Maison Morel — Renovation Lead Conversion",
  vertical: "Home Services / Renovation",
  industryKey: "home-services",
  industryLabel: "Home Services / Renovation",
  nicheKey: "renovation",
  nicheLabel: "Renovation",
  subnicheLabel: "General renovation",
  solutionKey: "lead-conversion",
  solutionLabel: "Lead Conversion",
  templateKey: "renovation-general-v1",
  demoType: "reference",
  maturity: "branch-scoped",
  runtimeStatus: EXECUTION.runtimeStatus,
  status: "building",
  statusLabel: "Demo lista · branch",
  summary: "Demo comercial action-first de captación, calificación, visita, presupuesto, follow-up y resultado para empresas de renovación.",
  scopeLabel: "Referencia comercial · todavía no reconciliada con main",
  capabilities: Object.freeze([
    "Website e intake",
    "Calificación",
    "Action Center",
    "Opportunity",
    "Conversación",
    "Visita técnica",
    "Quote follow-up",
    "Won / Lost y atribución",
    "Continuación a Reputation",
  ]),
  launch: Object.freeze({
    kind: "unavailable",
    reason: EXECUTION.target.reason,
  }),
});
